import { countString, stripTags } from "../../config/helpers";

const ArticleSchema = (props) => {
    //   TODO add url
    const {
       article,
    } = props;
    
    const removeAuthorSurname = (author) => {
        let author_name = author;
        const last_space = author_name.indexOf(" ");
        if(last_space !== -1){
          author_name = author_name.substr(0, last_space+2) + ".";
        }
        return author_name;
    }

    const returnTags = (tags) => {
        let value = "";
        Object.values(tags).map(tag => (
            value += tag.tag + ' '
        ));
        return value;
    }
 
    var json_ld = {
        "@context": "https://schema.org/",
        "@type": "Article",
        "headline": article.title,
        "image": article.image,
        "author": removeAuthorSurname(article.display_name),
        "keywords": returnTags(article.tags),
        "wordcount":  countString(stripTags(article.content)),
        "datePublished": article.date,
        "dateCreated": article.created_on,
        "dateModified": article.modified_on,
        "description": article.title,
        "articleBody": stripTags(article.content),
        "publisher": `${process.env.brand.brand_name} Ltd`
    };

    const productJsonId = {
        __html: JSON.stringify(json_ld),
    };
    
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={productJsonId}
            id="product-jsonld"
            key="product-jsonld"
        />
    );
};

export default ArticleSchema;
